import { Box } from '@mui/material'
import React from 'react'

export default function WorkingDots() {
  return (
    <Box
      aria-hidden={true}
      sx={{
        display: 'inline-flex',
        gap: 0.5,
        alignItems: 'center',
        '& span': {
          width: 6,
          height: 6,
          borderRadius: '50%',
          bgcolor: 'currentColor',
          animation: 'ca-typing 1.2s infinite ease-in-out',
        },
        '& span:nth-of-type(2)': { animationDelay: '0.16s' },
        '& span:nth-of-type(3)': { animationDelay: '0.32s' },
        '@keyframes ca-typing': {
          '0%, 80%, 100%': { transform: 'scale(0.6)', opacity: 0.35 },
          '40%': { transform: 'scale(1)', opacity: 1 },
        },
      }}
    >
      <span />
      <span />
      <span />
    </Box>
  )
}
